<div class="container" [style.width.px]="cardWidth()">
  <mat-card class="mat-card mat-elevation-z3">
    <a [matTooltip]="product().title" matTooltipTouchGestures="off" target="_blank" [href]="product().amazonlink" (click)="markViewed()">
      <div class="card-content">
        <span class="category">{{ product().category }}</span>
        @if (seen()) {
          <mat-icon class="seen-check">check</mat-icon>
        }
        <div class="image-container">
          <img [src]="product().imageurl" />
          <div class="price-container">
            @if (product().showprice && product().displaysavingspercent !== 0) {
              <div class="savings-total">
                <span>> {{ product().displaysavingspercent }}% off</span>
              </div>
            }
            <div class="spacer"></div>
            @if (product().displaypricedifference !== 0) {
              <div>
                Save over
                {{
                product().displaypricedifference
                | currency: currencyMap[product().domain]:"symbol":"1.0-0"
                }}
              </div>
            }
          </div>
        </div>
        <mat-card-content class="title-container">
          <p class="product-title">
            @if (debugMode && product().pricing_source) {
              <span class="pricing-source">[{{ product().pricing_source }}]</span>
              } {{ product().title }}
            </p>
          </mat-card-content>
          <div class="button-container">
            <div class="info-container">
              <div class="product-price">
                @if (product().unpriced) {
                  <span class="price-unavailable">Price not found</span>
                } @else {
                  {{
                  product().displayusedprice | currency: currencyMap[product().domain]
                  }}
                }
              </div>

              <div class="checked-date">
                On
                {{ product().checkeddate | date: "M/d, h:mm a" }}
              </div>
            </div>
            <a color="primary" mat-button>
              <mat-icon>launch</mat-icon>
              Amazon
            </a>
          </div>
        </div>
      </a>
    </mat-card>
  </div>
  <div class="row-container">
    <mat-card class="row-card">
      <div class="row">
        <div class="row-image-container">
          @if (seen()) {
            <mat-icon class="seen-check">check</mat-icon>
          }
          <img [src]="product().imageurl" />

          @if (product().displaysavingspercent !== 0) {
            <div
              class="row-savings-percent-image show-very-small"
              >
              > {{ product().displaysavingspercent }}% off
            </div>
          }
        </div>
        <div class="row-description-container">
          <div class="row-category">{{ product().category }}</div>
          <div class="row-title-container">
            <p class="row-product-title">
              @if (debugMode && product().pricing_source) {
                <span class="pricing-source">[{{ product().pricing_source }}]</span>
                } {{ product().title }}
              </p>
            </div>
            <div class="row-button-container">
              <div class="row-info-container">
                <div></div>
                <div class="row-price">
                  @if (product().unpriced) {
                    <span class="price-unavailable">Price not found</span>
                  } @else {
                    {{
                    product().displayusedprice | currency: currencyMap[product().domain]
                    }}
                  }
                  @if (product().displaysavingspercent !== 0) {
                    <div
                      class="row-savings-percent hide-very-small"
                      >
                      > {{ product().displaysavingspercent }}% off
                    </div>
                  }
                  <span class="row-date show-very-small">
                    On {{ product().checkeddate | date: "M/d, h:mm" }}
                  </span>
                </div>
                <div class="row-date hide-very-small">
                  On {{ product().checkeddate | date: "M/d, h:mm a" }}
                </div>
              </div>
              <a
                class="row-button"
                target="_blank"
                [href]="product().amazonlink"
                color="primary"
                mat-flat-button
                (click)="markViewed()"
                >
                <mat-icon>launch</mat-icon>
                Amazon
              </a>
            </div>
          </div>
        </div>
      </mat-card>
    </div>
